import { render, staticRenderFns } from "./AvailableTargetGroups.vue?vue&type=template&id=13168f52"
import script from "./AvailableTargetGroups.vue?vue&type=script&lang=js"
export * from "./AvailableTargetGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports